"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TeamMessageEditForm = _interopRequireDefault(require("./TeamMessageEditForm"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _TeamMessageEditForm.default;
exports.default = _default;